/**
 * Lifecycle of a `DunningRun` (batch dunning run) aggregate.
 *
 * - `PENDING` — created with items, awaiting worker pickup.
 * - `IN_PROGRESS` — worker has begun iterating items.
 * - `COMPLETED` — worker finished. Per-item outcomes may include SUCCESS,
 *   SKIPPED, and FAILED; partial item failures do NOT promote the aggregate
 *   to FAILED.
 * - `CANCELED` — user-initiated abort while still PENDING or IN_PROGRESS.
 * - `FAILED` — reserved for the sweeper-only catastrophic path (stuck
 *   IN_PROGRESS runs older than the orphan threshold). User-facing commands
 *   cannot transition the aggregate to this state.
 */
export var DunningRunStatus;
(function (DunningRunStatus) {
    DunningRunStatus["PENDING"] = "pending";
    DunningRunStatus["IN_PROGRESS"] = "in_progress";
    DunningRunStatus["COMPLETED"] = "completed";
    DunningRunStatus["CANCELED"] = "canceled";
    DunningRunStatus["FAILED"] = "failed";
})(DunningRunStatus || (DunningRunStatus = {}));
//# sourceMappingURL=dunning-run-status.enum.js.map